import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import HttpClient from '../../utils/HttpClient';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import toast from 'react-hot-toast';
import NonMemberModal from '../../Component/Modal/NonMemberModal';
import moment from 'moment';
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import BusinessLIstingModal from '../../Component/Modal/BusinessLIstingModal';
import BusinessLikesModal from '../../Component/Modal/BusinessLikesModal';
import { formatLikeCounter } from '../../utils/helper';
import BusinessFollowModal from '../../Component/Modal/BusinessFollowModal';
import BlmEnquiryList from './BlmEnquiryList';
import { fetchBLMUsersData } from '../../Redux/Slice/BLMSlice';
import { useDispatch } from 'react-redux';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"

const BLMGoldRequest = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
    const [isBusinessLikeModalOpen, setIsBusinessLikeModalOpen] = useState(false);
    const [isBusinessFollowModalOpen, setIsBusinessFollowModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [selectedBusinessLikeDetails, setSelectedBusinessLikeDetails] = useState();
    const [selectedBusinessFollowDetails, setSelectedBusinessFollowDetails] = useState();
    const [AllData, setAllData] = useState([]);
    const [ExcelSheetData, setExcelSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [filterCountryState, setfilterCountryState] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            // width: "5%",
            wrap: true
        },
        {
            name: 'Customer#',
            selector: row => row.customerNo,
        },
        {
            name: 'Subscription',
            selector: row => row.subscriptionPlan,
            // width: "5%",
            wrap: true
        },
        {
            name: 'View',

            cell: (row) => (
                <>
                    {
                        row.businessStatus &&
                        <>
                            <i className="fa-solid fa-eye " onClick={() => handleBusinessView(row.id)}
                                style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
                        </>
                    }
                </>
            ),

            // width: "10%",
            wrap: true,
        },
        {
            name: 'Like(s)',
            cell: (row) => (
                <>
                    {
                        row.businessStatus &&
                        <>
                            {row?.businessLikeCount ? (<>{formatLikeCounter(row.businessLikeCount)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleBusinessLikesView(row)}
                                style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                        </>
                    }
                </>
            ),

            // width: "10%",
            wrap: true,
            align: "center",
        },
        {
            name: 'Follower(s)',

            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                {row?.businessFollowCount ? (<>{formatLikeCounter(row.businessFollowCount)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleBusinessFollowersView(row)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                            </>
                        )
                    }
                </>
            ),

            // width: "10%",
            wrap: true,
            align: "center",
        },
        {
            name: 'Enquiry',

            cell: (row) => (
                <>
                    {row?.referenQuiries.length > 0 ? (<>{formatLikeCounter(row?.referenQuiries.length)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleEnquiryDisplay(row?.referenQuiries)}
                        style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                </>
            ),
            // width: "5%",
        },
        {
            name: 'Company Name',
            selector: row => row.companyName,
            // width: "10%",
            wrap: true
        },
        {
            name: 'Company Type',
            selector: row => row.TypeOfCompany,
            // width: "15%"
        },
        // {
        //     name: 'Services',
        //     selector: row => {
        //         return (
        //             <>
        //                 <ul>
        //                     {
        //                         row?.services?.map((item) => { return <><li>{item}</li></> })
        //                     }
        //                 </ul>
        //             </>
        //         )
        //     },
        //     width: "13%",
        //     wrap: true,
        // },
        // {
        //     name: 'Keywords',
        //     selector: row => {
        //         return (
        //             <>
        //                 {
        //                     row?.keywords?.map((item, key) => { return <>{item}{row?.keywords?.length > key + 1 && ", "}</> })
        //                 }
        //             </>
        //         )
        //     },
        //     width: "13%",
        //     wrap: true,
        // },
        {
            name: 'Person Name',
            selector: row => row.personName,
            // width: "10%",
            wrap: true
        },
        {
            name: 'Upgrade',
            selector: row => row.upgrade,
            // width: "10%"
        },
        // {
        //     name: 'Payment',
        //     selector: row => row.payment,
        // },
        // {
        //     name: 'Suspend',
        //     selector: row => row.suspend,
        // },
        // {
        //     name: 'Business Page',
        //     selector: row => row.businessStatus,
        // },
        // {
        //     name: 'Action',
        //     selector: row => row.action,
        // },
    ];

    const [displayEnquiry, setDisplayEnquiry] = useState(false)
    const [postEnquiry, setPostEnquiry] = useState([])
    //Enquiry VIEW
    const handleEnquiryDisplay = async (data) => {
        setDisplayEnquiry(true)
        setPostEnquiry(data)
    }

    const handleUpgrade = async (e, id, plan, code) => {
        e.preventDefault()
        const data = {
            subscriptionId: plan,
            planUpgradeRequested: false,
            password: code,
        }
        const res = await HttpClient.requestData("user/" + id, "PUT", data)
        if (res && res?.status) {
            toast.success("Upgraded Succesfully")
            // navigate("/non-member-business-list")
            getCategoryWiseData();
        }
        else {
            toast.error(res?.msg)
        }
    }

    const handlePlanUpgrade = async (e, id) => {
        e.preventDefault()
        const res = await HttpClient.requestData("upgrade-plan-approve/" + id, "PUT")
        if (res && res?.status) {
            toast.success("Upgraded Succesfully")
            // navigate("/non-member-business-list")
            getCategoryWiseData();
            dispatch(fetchBLMUsersData())
        }
        else {
            toast.error(res?.msg)
        }
    }

    const getCategoryWiseData = async () => {
        setIsLoading(true);
        // const res = await HttpClient.requestData("non-member-user", "GET", {});
        const res = await HttpClient.requestData("both-users", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data
                .filter((item) => item.businessStatus && item.status === "Active" && item.planUpgradeRequested && item.upgradedSubscriptionId === "66d897d8094058c609c7183c")
                // .filter((item) => item.status === "Active")
                // .filter((item) => item.companyName)
                .map((item, i) => ({
                    id: item?._id,
                    sl: i + 1,
                    customerNo: item?.SLNo || "******",
                    TypeOfCompany: item?.TypeOfCompany,
                    companyName: item?.companyName,
                    personName: item?.personName,
                    services: item?.businessProductCat,
                    keywords: item?.businessProductkeywords,
                    designation: item?.designation,
                    emailId: item?.emailId,

                    mobileNo: item?.mobileNo,
                    whatsappNo: item?.whatsappNo,
                    directoryCount: item?.directoryCount,

                    createdOn: moment(item?.createdOn).format(format1),
                    businessStatus: item?.businessStatus,

                    businessWebsiteLink: item?.businessWebsiteLink,
                    businessFacebookLink: item?.businessFacebookLink,
                    businessInstaLink: item?.businessInstaLink,
                    businessLinkedInLink: item?.businessLinkedInLink,
                    businessLocationLink: item?.businessLocationLink,

                    businessLikeCount: item?.businessLikeCount,
                    businessLikes: item?.businessLikes.sort(
                        (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                    ),
                    businessFollowCount: item?.businessFollowCount,
                    businessFollow: item?.businessFollow.sort(
                        (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                    ),
                    referenQuiries: item?.referenQuiries || [],
                    subscriptionPlan: item?.subscriptionData?.plan || "N/A",
                    /////
                    emirate: item?.emirate,
                    country: item?.country,
                    telephoneNo: item?.telephoneNo,
                    paymentStatus: item?.paymentStatus ? "Paid" : "No",

                    // loginStatus: item?.loginStatus ? <button

                    //     type="button" className="btn btn-success floating-message px-3"
                    //     data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                    //     style={{ fontSize: "16px" }}>Active</button> : <button

                    //         type="button" className="btn btn-danger floating-message px-3"
                    //         data-toggle="tooltip" data-placement="top" title="Click to Activate">
                    //     Inactive
                    // </button>,

                    payment: <div>
                        {
                            item?.paymentStatus ? <button
                                onClick={() => handlePayment(item?._id, false)}
                                type="button" className="btn btn-warning _floating-message px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Unpaid">
                                Paid
                            </button> : <button
                                onClick={() => handlePayment(item?._id, true)}
                                type="button" className="btn btn-primary _floating-message px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Paid"
                                style={{ fontSize: "16px" }}>Payment</button>
                        }
                    </div>,

                    suspend: <div>
                        {
                            item?.suspendStatus ? <button
                                onClick={() => handleSuspend(item?._id, false)}
                                type="button" className="btn btn-danger _floating-message _px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Unpaid">
                                Suspended
                            </button> : <button
                                onClick={() => handleSuspend(item?._id, true)}
                                type="button" className="btn btn-success _floating-message _px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Paid"
                                style={{ fontSize: "16px" }}>Suspend</button>
                        }
                    </div>,



                    status: <div>
                        {
                            item?.status === "Pending" ? <button
                                onClick={() => handleActive(item?._id)}
                                type="button" className="btn btn-danger _floating-message px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Activate">
                                Pending
                            </button> : <button
                                onClick={() => handlePending(item?._id)}
                                type="button" className="btn btn-success _floating-message px-3"
                                data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                                style={{ fontSize: "16px" }}>{item?.status}</button>
                        }
                    </div>,
                    businessStatus: <div>
                        {
                            item?.businessStatus === false ? <button
                                onClick={() => handleActive(item?._id)}
                                type="button" className="btn btn-danger _floating-message _px-3"
                            // data-toggle="tooltip" data-placement="top" title="Click to Activate"
                            >
                                Inactive
                                {/* <span style={{ fontSize: "80%", display: "block" }}>Click to Activate</span> */}
                            </button> : <button
                                onClick={() => handlePending(item?._id)}
                                type="button" className="btn btn-success _floating-message _px-3"
                            // data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                            >
                                Active
                                {/* <span style={{ fontSize: "80%", display: "block" }}>Click to Deativate</span> */}
                            </button>
                        }
                    </div>,
                    action: <EditDeleteIcon

                        onClickEdit={(e) => handleEdit(item)}

                    />,
                    upgrade: <div>
                        {
                            item?.planUpgradeRequested ?
                                <button
                                    // onClick={(e) => handleUpgrade(e, item?._id, item?.upgradedSubscriptionId, item?.passwordView)}
                                    onClick={(e) => handlePlanUpgrade(e, item?._id)}
                                    type="button" className="btn btn-sm btn-success my-2"
                                >
                                    Upgrade to<br />{item?.upgradedSubscriptionData?.plan} Plan
                                </button>
                                :
                                <button
                                    type="button" className="btn btn-sm my-2" disabled>
                                    Not<br />Requested
                                </button>
                        }
                    </div>,
                    // action: <EditDeleteIcon

                    //     onClickEdit={(e) => handleEdit(item)}
                    //     onClickDelete={(e) => handleDelete(item?._id)}
                    // />
                }));

        } else {
            setIsLoading(false);
        }
        // Filter data based on search input
        const filteredData = apiData?.filter(item =>
            item?.TypeOfCompany?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.companyName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.personName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.designation?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emailId?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.mobileNo?.toString()?.includes(searchInput) ||
            item?.country?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emirate?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.customerNo?.toString()?.toLowerCase()?.includes(searchInput?.toLowerCase())
        );
        setAllData(filteredData);

        setExcelSheetData(filteredData.map(item => {
            const { status, action, loginStatus, ...rest } = item;
            return rest;
        }));

        // setExcelSheetData(filteredData?.map((item, i) =>
        // ({
        //     Sl: item?.sl,
        //     CompanyName: item?.companyName,
        //     TypeOfCompany: item?.TypeOfCompany,
        //     Services: item?.services?.join(', '),
        //     Keywords: item?.keywords?.join(', '),
        //     personName: item?.personName,
        //     Website: item?.businessWebsiteLink,
        //     Facebook: item?.businessFacebookLink,
        //     Instagram: item?.businessInstaLink,
        //     LinkedIn: item?.businessLinkedInLink,
        //     Location: item?.businessLocationLink
        // })
        // ))

        // const filteredD = filteredData.filter(item => item.hasOwnProperty('status') && item.hasOwnProperty('action'));
    }

    //Activate
    const handlePending = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Pending",
            businessStatus: false,
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Deactivated Successfully");
            getCategoryWiseData();
        } else {
            setIsLoading(false);
        }
    }
    //Payment
    const handlePayment = async (id, status) => {
        setIsLoading(true);
        const data = {
            paymentStatus: status,
        }

        const res = await HttpClient.requestData(`payment-status-update/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Payment Status Updated Successfully");
            getCategoryWiseData();
        }
    }
    //Suspend
    const handleSuspend = async (id, status) => {
        setIsLoading(true);
        const data = {
            suspendStatus: status,
        }

        const res = await HttpClient.requestData(`suspend-status-update/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Updated Successfully");
            getCategoryWiseData();
        }
    }
    //Pending
    const handleActive = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Active",
            businessStatus: true,
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Activated Successfully");
            getCategoryWiseData();
        }
    }
    //MODAL VIEW
    const handleView = async (id) => {

        setSelectedDetails(id);
        setIsModalOpen(true);
    }
    //BUSINESS MODAL VIEW
    const handleBusinessView = async (id) => {

        setSelectedDetails(id);
        setIsBusinessModalOpen(true);
    }
    //BUSINESS LIKES MODAL VIEW
    const handleBusinessLikesView = async (data) => {

        setSelectedBusinessLikeDetails(data?.businessLikes);
        setIsBusinessLikeModalOpen(true);
    }
    //BUSINESS FOLLOW MODAL VIEW
    const handleBusinessFollowersView = async (data) => {

        setSelectedBusinessFollowDetails(data?.businessFollow);
        setIsBusinessFollowModalOpen(true);
    }
    //edit
    const handleEdit = (item) => {
        navigate("/non-member-business-list-edit", { state: { ...item, returnUrl: "approved-blm-users" } })
    }
    // Function to export data to Excel
    // const exportToExcel = () => {
    //     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const fileExtension = '.xlsx';
    //     const fileName = 'non_member_business_list';

    //     const ws = XLSX.utils.json_to_sheet(ExcelSheetData);
    //     const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //     const data = new Blob([excelBuffer], { type: fileType });
    //     saveAs(data, fileName + fileExtension);
    // };
    const exportToExcel = () => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const fileName = "blm_members_data";

        const exportMembers = ExcelSheetData.map((item, idx) => ({
            customerNo: item.customerNo || "",
            subscriptionPlan: item.subscriptionPlan || "",
            paymentStatus: item.paymentStatus,
            companyName: item.companyName || "",
            typeOfBusiness: item.TypeOfCompany || "",
            personName: item.personName || "",
            designation: item.designation || "",
            emailId: item.emailId || "",
            contactNumber: item.phone_code ? `${item.phone_code}${item.telephoneNo || ""}` : item.telephoneNo || "",
            contactNumber2: item.phone_code ? `${item.phone_code}${item.mobileNo || ""}` : item.mobileNo || "",
            website: item.businessWebsiteLink || item.webAddress,
            state: item.emirate,
            country: item.country

            // directoryCount: Number(item.directoryCount) || 0,
            // businessStatus: Boolean(item.businessStatus),
            // fullMobile: item.phone_code ? `${item.phone_code}${item.mobileNo}` : item.mobileNo,
        }));

        const headerMap = {
            customerNo: "Customer ID",
            subscriptionPlan: "Plan",
            paymentStatus: "Payment",
            typeOfBusiness: "Type Of Business",
            personName: "Person Name",
            designation: "Designation",
            emailId: "Email Id",
            contactNumber: "Contact Number",
            contactNumber2: "Contact Number 2",
            website: "Website",
            state: "State",
            country: "Country"
        };

        const fields = Object.keys(headerMap);
        const dataWithHeaders = exportMembers.map((row) =>
            fields.map((field) => row[field])
        );

        dataWithHeaders.unshift(Object.values(headerMap));

        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
    };


    useEffect(() => {
        getCategoryWiseData();
    }, [searchInput])

    const toggleEnquiryView = () => {
        setDisplayEnquiry(!displayEnquiry)
    }

    return (
        <>
            {
                displayEnquiry ? (<BlmEnquiryList data={postEnquiry} backToPosts={toggleEnquiryView} />) :
                    (
                        <>
                            <div className="d-flex justify-content-end">
                                <div className="form-header">

                                    <CustomLoader loading={isLoading} />
                                    <section className="piechartsBox_area">
                                        <div
                                            style={headLineStyle}
                                            className="page-headline"
                                        >
                                            Gold Plan Requested BLM Users
                                        </div>
                                        <div className=" d-flex justify-content-between  mb-2" >
                                            {/* filter by country and state */}
                                            {!filterCountryState &&
                                                <div className="d-flex flex-column  justify-content-between  mt-3" >
                                                    {/* <div className='mb-2'>
                                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="formGroupExampleInput">Emirate <span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div> */}
                                                </div>}
                                            <div className="Search_box">
                                                <form className="form-inline">
                                                    <input
                                                        className="form-control h-75"
                                                        type="search"
                                                        placeholder="Search"
                                                        aria-label="Search"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                    />
                                                    <div className="Search_icon">
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </div>
                                                </form>
                                                <div className="d-flex justify-content-end">
                                                    {/* Your existing JSX code */}
                                                    <button className="btn btn-primary" onClick={exportToExcel}>Export to Excel</button>
                                                    {/* Your existing JSX code */}
                                                </div>
                                            </div>
                                        </div>


                                        <form>

                                            <div>

                                                <DataTable
                                                    columns={columns}
                                                    data={AllData}
                                                    pagination
                                                    striped
                                                    className=" rounded "
                                                    customStyles={customStyles}
                                                />
                                            </div>
                                        </form>
                                    </section>
                                    <NonMemberModal
                                        isOpen={isModalOpen}
                                        closeModal={() => setIsModalOpen(false)}
                                        details={selectedDetails}
                                    />
                                    <BusinessLIstingModal
                                        isOpen={isBusinessModalOpen}
                                        closeModal={() => setIsBusinessModalOpen(false)}
                                        details={selectedDetails}
                                    />
                                    <BusinessLikesModal
                                        isOpen={isBusinessLikeModalOpen}
                                        closeModal={() => setIsBusinessLikeModalOpen(false)}
                                        details={selectedBusinessLikeDetails}
                                    />
                                    <BusinessFollowModal
                                        isOpen={isBusinessFollowModalOpen}
                                        closeModal={() => setIsBusinessFollowModalOpen(false)}
                                        details={selectedBusinessFollowDetails}
                                    />
                                </div>

                            </div>
                        </>
                    )
            }
        </>

    )
}

export default BLMGoldRequest